(function ($) {

    const ICONS = {
        chevronDown: '<svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.5974 0.477418C18.8783 0.758668 19.0361 1.13992 19.0361 1.53742C19.0361 1.93492 18.8783 2.31617 18.5974 2.59742L10.5974 10.5974C10.3162 10.8783 9.93492 11.0361 9.53742 11.0361C9.13992 11.0361 8.75867 10.8783 8.47742 10.5974L0.477416 2.59742C0.330042 2.46009 0.211838 2.29449 0.129854 2.11049C0.0478701 1.92649 0.00378701 1.72787 0.000233445 1.52646C-0.00332012 1.32506 0.0337287 1.125 0.109171 0.938222C0.184613 0.751445 0.296902 0.581779 0.439339 0.439341C0.581777 0.296904 0.751444 0.184614 0.938221 0.109172C1.125 0.0337296 1.32506 -0.00332013 1.52646 0.00023344C1.72787 0.00378701 1.92649 0.047871 2.11049 0.129855C2.29449 0.211839 2.46009 0.330044 2.59742 0.477418L9.53742 7.41742L16.4774 0.477418C16.7587 0.196517 17.1399 0.0387371 17.5374 0.0387371C17.9349 0.0387371 18.3162 0.196517 18.5974 0.477418Z" fill="#FFB86E"/></svg>'
    };

    const buildWidgetMarkup = (options) => {
        const optionsHtml = options.map((opt) => `
            <div class="select-picker--option" data-value="${opt.value}" role="option">${opt.label}</div>`).join('');

        return `
            <div class="select-picker" data-select-picker>
                <div class="select-picker--field">
                    <button type="button" class="select-picker--trigger" data-select-trigger>
                        <span class="select-picker--display" data-select-display></span>
                    </button>
                    <button type="button" class="select-picker--icon-btn" data-select-icon-btn aria-haspopup="listbox" aria-expanded="false" aria-label="Open options">
                        ${ICONS.chevronDown}
                    </button>
                </div>
                <div class="select-picker--panel" data-select-panel role="listbox">
                    ${optionsHtml}
                    <span class="select-picker--more" data-select-more aria-hidden="true">${ICONS.chevronDown}</span>
                </div>
            </div>`;
    };

    class SelectPicker {
        constructor(select) {
            this.select = select;
            this.select.classList.add('select-picker--native-select');

            // the blank placeholder <option value=""> represents "nothing chosen yet",
            // not a real choice, so it's excluded from the rendered list
            this.options = Array.from(select.options)
                .filter((o) => o.value !== '')
                .map((o) => ({ value: o.value, label: o.textContent.trim() }));

            select.insertAdjacentHTML('afterend', buildWidgetMarkup(this.options));
            this.el = select.nextElementSibling;
            this.trigger = this.el.querySelector('[data-select-trigger]');
            this.iconBtn = this.el.querySelector('[data-select-icon-btn]');
            this.display = this.el.querySelector('[data-select-display]');
            this.panel = this.el.querySelector('[data-select-panel]');
            this.moreIndicator = this.el.querySelector('[data-select-more]');
            this.optionEls = Array.from(this.el.querySelectorAll('[data-value]'));
            this.activeIndex = -1;

            this.renderDisplay();
            this.bindEvents();
        }

        renderDisplay() {
            const selectedOption = this.select.options[this.select.selectedIndex];
            this.display.textContent = selectedOption ? selectedOption.textContent.trim() : '';

            this.optionEls.forEach((el) => {
                const isSelected = el.dataset.value === this.select.value;
                el.classList.toggle('select-picker--option--selected', isSelected);
                el.setAttribute('aria-selected', isSelected ? 'true' : 'false');
            });
        }

        selectValue(value) {
            this.select.value = value;
            this.select.dispatchEvent(new Event('change', { bubbles: true }));
            this.renderDisplay();
            this.close();
        }

        isOpen() {
            return this.el.classList.contains('select-picker--open');
        }

        open() {
            this.el.classList.add('select-picker--open');
            this.iconBtn.setAttribute('aria-expanded', 'true');

            this.activeIndex = this.optionEls.findIndex((el) => el.dataset.value === this.select.value);
            this.focusOption(this.activeIndex);

            this.moreIndicator.style.display = this.panel.scrollHeight > this.panel.clientHeight ? 'flex' : 'none';
        }

        close() {
            this.el.classList.remove('select-picker--open');
            this.iconBtn.setAttribute('aria-expanded', 'false');
            this.optionEls.forEach((el) => el.classList.remove('select-picker--option--active'));
            this.activeIndex = -1;
        }

        focusOption(index) {
            this.optionEls.forEach((el) => el.classList.remove('select-picker--option--active'));
            const target = this.optionEls[index];
            if (target) {
                target.classList.add('select-picker--option--active');
                target.scrollIntoView({ block: 'nearest' });
            }
        }

        moveActive(dir) {
            const max = this.optionEls.length - 1;
            const next = this.activeIndex === -1 ? 0 : this.activeIndex + dir;
            this.activeIndex = Math.min(max, Math.max(0, next));
            this.focusOption(this.activeIndex);
        }

        bindEvents() {
            [this.trigger, this.iconBtn].forEach((control) => {
                control.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.isOpen() ? this.close() : this.open();
                });
            });

            this.optionEls.forEach((el) => {
                el.addEventListener('click', () => this.selectValue(el.dataset.value));
            });

            this.el.addEventListener('keydown', (e) => {
                if (!this.isOpen()) {
                    if (['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(e.key)) {
                        e.preventDefault();
                        this.open();
                    }
                    return;
                }

                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    this.moveActive(1);
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    this.moveActive(-1);
                } else if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    const active = this.optionEls[this.activeIndex];
                    if (active) {
                        this.selectValue(active.dataset.value);
                    }
                } else if (e.key === 'Escape') {
                    e.preventDefault();
                    this.close();
                }
            });

            document.addEventListener('click', (e) => {
                if (this.isOpen() && !this.el.contains(e.target)) {
                    this.close();
                }
            });
        }
    }

    const init = (selector = '.enrollment--field select') => {
        document.querySelectorAll(selector).forEach((select) => {
            if (!select.dataset.selectPickerInit) {
                select.dataset.selectPickerInit = 'true';
                new SelectPicker(select);
            }
        });
    };

    window.YuviwelSelect = { init };

})(jQuery);
